import { type FC } from 'react'
import { useRedtailContactSync, useRedtailCalendarSync } from '../IntegrationSpecificSettings/Redtail/hooks'
import { type CrmIntegrationSettings, type CrmSettingsProviderProps } from './types'

export const RedtailCrmSettingsProvider: FC<CrmSettingsProviderProps> = ({ children }) => {
  const contact = useRedtailContactSync()
  const calendar = useRedtailCalendarSync()

  const settings: CrmIntegrationSettings = {
    contactSync: contact.autoSync,
    calendarSync: calendar.autoSync,
    isSyncDisabled: contact.isSyncDisabled,
    isFetching: contact.isFetching || calendar.isFetching,
    isSaving: contact.isSaving || calendar.isSaving,
    save: async (patch) => {
      const ops: Promise<void>[] = []
      if (patch.contactSync !== undefined) {
        ops.push(contact.saveAutoSync(patch.contactSync))
      }
      if (patch.calendarSync !== undefined) {
        ops.push(calendar.save(patch.calendarSync))
      }
      await Promise.all(ops)
    },
  }

  return <>{children(settings)}</>
}
